module.exports = __webpack_public_path__ + "img/icon_individual.705e4e85.png";